function guAddToCart(evt){
    evt.preventDefault();
    const variantId = evt.target.dataset.variant;
    const items = [{
                'id': variantId,
                'quantity': 1,
                'properties': {
                    '__xs': true,
                }
            }];
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items:items}),
    }).then((response) => response.text()).then((data) => {
        // document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        //     bubbles: true,
        // }));
        document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
                variant: variantId,
                quantity: 1
            }
        }));
    });
}

document.addEventListener('click', (evt) => {
    if(evt.target.dataset.type === 'gu-pr-atc'){
        guAddToCart(evt);
    }
});
